module.exports = __webpack_public_path__ + "days_gone.png?7ce69f364283dbba0b731597ec8fdcf1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/days_gone.png
// module id = 214
// module chunks = 0